import React from 'react';

const PayPalButton = () => {
  const buttonStyle = {
    textAlign: 'center',
    border: 'none',
    borderRadius: '0.25rem',
    minWidth: '11.625rem',
    padding: '0 2rem',
    height: '2.625rem',
    fontWeight: 'bold',
    backgroundColor: '#FFD140',
    color: '#000000',
    fontFamily: '"Helvetica Neue", Arial, sans-serif',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    cursor: 'pointer',
  };

  const formStyle = {
    display: 'inline-grid',
    justifyItems: 'center',
    alignContent: 'start',
    gap: '0.5rem',
  };

  const footerTextStyle = {
    fontSize: '0.75rem',
  };

  const paypalLogoStyle = {
    height: '0.875rem',
    verticalAlign: 'middle',
  };

  return (
    <form
      action="https://www.paypal.com/ncp/payment/G9YARESL3Z4AC"
      method="post"
      target="_blank"
      style={formStyle}
    >
      <input type="submit" value="Buy Now" style={buttonStyle} />
      <img
        src="https://www.paypalobjects.com/images/Debit_Credit_APM.svg"
        alt="cards"
      />
      <section style={footerTextStyle}>
        Powered by{' '}
        <img
          src="https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-wordmark-color.svg"
          alt="paypal"
          style={paypalLogoStyle}
        />
      </section>
    </form>
  );
};

export default PayPalButton;
